import { render, staticRenderFns } from "./aboutList.vue?vue&type=template&id=12fd2a64&scoped=true"
import script from "./aboutList.vue?vue&type=script&lang=js"
export * from "./aboutList.vue?vue&type=script&lang=js"
import style0 from "./aboutList.vue?vue&type=style&index=0&id=12fd2a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd2a64",
  null
  
)

export default component.exports